import React from "react"

import BlogHeroMedia from "../BlogHeroMedia"
import { PartnersLogos } from "../PartnersLogos"
import { Breadcrumbs, BannerContent, BannerContentSmall, SubCategories } from "../BlogComponents"
import { TranslationIcon } from "../Icons"

import "./index.css"

const BlogTemplateBanner = ({ variant, post, postCategories, postCategoryTitles, formattedDate }) => {
    const hasBackdropOverlay = (post.hasBackdropOverlay !== null || post.hasBackdropOverlay) ? true:false
    if(variant !== 'Hero with Small Feature Image') {
        return (
            <div className={`blog-banner ${variant === 'Hero with Slanted Effect' ? 'banner--slanted' : 'banner--full'}`}>
                <BlogHeroMedia data={post} className={`${post.heroMediaLink !== null ? 'blog-banner-video' : 'global-hero'}${hasBackdropOverlay ? ' overlay':''}`} template={post.blogTemplate}>
                    {variant === 'Hero with Slanted Effect' && <div className="slanted-effect"></div>}
                    <div className="relative container-custom">
                        <Breadcrumbs post={post} />
                        {post.translation !== null && (
                            <div className={`flex wrap justify-center translation${post.isHeaderDark ? ' dim':' bright'}`}>
                                <TranslationIcon />
                                {post.translation.map((item, index)=>(
                                    <div key={index} className="item">
                                        <a href={`/${item?.mainCategories?.slugId}${encodeURI(item.buttonLink)}`}>{item.buttonName}</a>
                                    </div>
                                ))}
                            </div>
                        )}
                        <PartnersLogos hasPartnerLogo={post?.companyLogo} partnerLogo={post?.companyLogo} />
                        <BannerContent post={post} variant={variant} formattedDate={formattedDate} textLarge={post.parentCategory.categoryName === 'Packaging Tips'}/>
                    </div>
                </BlogHeroMedia>
            </div>
        )
    } else {
        return (
            <div className="blog-banner banner--small-feature">
                <div className="container-custom">
                    {/* <SubCategories post={post} postCategoryTitles={postCategoryTitles} postCategories={postCategories} hasCustomizeSpacing={true} /> */}
                    <Breadcrumbs post={post} isCenter={true} />
                    {post.translation !== null && (
                        <div className="flex wrap justify-center translation">
                            <TranslationIcon />
                            {post.translation.map((item, index)=>(
                                <div key={index} className="item">
                                    <a href={`/page${encodeURI(item.buttonLink)}`}>{item.buttonName}</a>
                                </div>
                            ))}
                        </div>
                    )}
                    <PartnersLogos hasPartnerLogo={post?.companyLogo} partnerLogo={post?.companyLogo} />
                    <BannerContentSmall post={post} formattedDate={formattedDate} />
                </div>
            </div>
        )
    }
}

export default BlogTemplateBanner